import { apiDelete } from '../../Dataman';
import { DEALS_PATHS } from './deals_paths';
import Backend from '@/app/Dataman-Backend';

export const purchaseInvoiceFilesApi = {
  dealPurchaseInvoiceFiles: {
    remove: (id) => apiDelete(`${DEALS_PATHS.dealPurchaseInvoiceFiles}/${id}`),
    download: (id) =>
      Backend.loadBlobData({
        url: `${DEALS_PATHS.dealPurchaseInvoiceFiles}/${id}/file`,
        method: 'get',
        responseType: 'blob',
        headers: { accept: 'application/octet-stream' },
      }),
    create: ({ deal, file, onUploadProgress }) => {
      const formData = new FormData();
      formData.append('deal', deal);
      formData.append('file', file);
      return Backend.post({
        url: DEALS_PATHS.dealPurchaseInvoiceFiles,
        headers: {
          'Content-type': 'multipart/form-data',
        },
        data: formData,
        onUploadProgress,
      });
    },
  },
};
